function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M46.7,59.4H9.5L19,31.8v-13h17.1v13L46.7,59.4z M13.7,56.4h28.6l-9.2-24.1V21.8H22v10.5L13.7,56.4z"
}))));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 14.4,
  y: 47.8,
  width: 26.3,
  height: 3
}))));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 20.5,
  y: 30.6,
  width: 14.1,
  height: 3
}))));

var SvgExperiment = function SvgExperiment(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/experiment.0c7f7f3f.svg";
export { SvgExperiment as ReactComponent };